import { _reducer } from './routes.reducers';

export * from './routes.actions';
export default _reducer;
